/* eslint-disable jira/filename-case */
import { withChoreographedToggle } from '@jira/platform__choreographer-services/src/main.tsx';
import type { ChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
import type { PopupProps } from '@atlaskit/popup/types';
// eslint-disable-next-line no-restricted-imports, jira/restricted/@atlaskit+popup
import { Popup } from '@atlaskit/popup/popup';

export const ChoreographerPopup: {
	(props: PopupProps & ChoreographedComponentProps): React.JSX.Element;
	displayName: string;
} = withChoreographedToggle<PopupProps>(Popup, 'isOpen', 'content');
